import React, { useState, useRef, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { saveSvgAsPng } from "save-svg-as-png";
import qrService from "../../api/services/qrService";
import Loader from "../../components/loader/loader";
import SearchIcon from "../../components/icons/searchIcon";
import DownloadIcon from "../../components/icons/DownloadIcon";
import { Fancybox } from "@fancyapps/ui";
import "./GenerateQrCode.css";

import example1 from "../../assets/images/qr/board.png";
import partnerService from "../../api/services/partnerService";
import { getWindowDimensions } from "../../components/bankingDetails/BankingDetails";

function svgToImage(svgElement, callback) {
  try {
    // Создаем объект Blob из SVG элемента
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], {
      type: "image/svg+xml;charset=utf-8",
    });
    const url = URL.createObjectURL(svgBlob);

    // Создаем изображение и загружаем URL Blob
    const img = new Image();
    img.onload = function () {
      // Создаем Canvas элемент
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      // Рисуем изображение на Canvas
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      // Получаем Data URL из Canvas
      const imgData = canvas.toDataURL("image/png");

      // Освобождаем память, удаляя объект URL
      URL.revokeObjectURL(url);

      // Возвращаем результат через callback
      callback(imgData);
    };
    img.src = url;
  } catch (e) {}
}
function drawTextOnImage(imageSrc, text, x, y, font, color, callback) {
  // Создаем изображение и загружаем URL
  const img = new Image();
  img.crossOrigin = "Anonymous"; // Для обхода проблем с CORS
  img.onload = function () {
    // Создаем Canvas элемент
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;

    // Рисуем изображение на Canvas
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    // Устанавливаем свойства текста
    ctx.font = font;
    ctx.fillStyle = color;

    // Рисуем текст
    ctx.fillText(text, x, y);

    // Получаем Data URL из Canvas
    const imgData = canvas.toDataURL("image/png");

    // Возвращаем результат через callback
    callback(imgData);
  };
  img.src = imageSrc;
}
function overlayImages(baseImgUrl, overlayImgUrl, settings, callback) {
  // Загружаем базовое изображение
  const baseImg = new Image();
  baseImg.crossOrigin = "Anonymous";
  baseImg.onload = function () {
    // Создаем Canvas для базового изображения
    const canvas = document.createElement("canvas");
    canvas.width = baseImg.width;
    canvas.height = baseImg.height;
    const ctx = canvas.getContext("2d");

    // Рисуем базовое изображение
    ctx.drawImage(baseImg, 0, 0);

    // Загружаем изображение для наложения
    const overlayImg = new Image();
    overlayImg.crossOrigin = "Anonymous";
    overlayImg.onload = function () {
      // Рисуем изображение для наложения поверх базового
      ctx.drawImage(
        overlayImg,
        settings.x,
        settings.y,
        settings.width,
        settings.height
      );

      // Получаем Data URL из Canvas
      const resultImgData = canvas.toDataURL("image/png");

      // Возвращаем результат через callback
      callback(resultImgData);
    };
    overlayImg.src = overlayImgUrl;
  };
  baseImg.src = baseImgUrl;
}

function GenerateQrCode() {
  const svgRef = useRef();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [qrLink, setQrLink] = useState("");
  const [isLoading, setIsLoading] = useState();
  const [name, setName] = useState();

  const downloadSVG = () => {
    saveSvgAsPng(document.getElementById("qrCode"), `${name}_QR.png`, {
      scale: 5,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    getQrCode();
  }, []);

  const getQrCode = async () => {
    try {
      const resp = await qrService.getQrCode();
      if (resp.status) {
        setQrLink(resp.link);
        setIsLoading(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    Fancybox.bind('[data-fancybox="gallery"]', {
      // Настройки Fancybox
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [combinedImageUrls, setCombinedImageUrls] = useState({});

  useEffect(() => {
    try {
      if (!isLoading && svgRef.current) {
        const resp = partnerService.getPartner().then((data) => {
          if (
            data &&
            data?.data &&
            data?.data.length > 0 &&
            data?.data[0]?.BANNERFILE &&
            data?.data[0]?.PARTNERNAME
          ) {
            setName(data?.data[0]?.PARTNERNAME);
            const bannerImage = data?.data[0]?.BANNERFILE || "";
            const titleStore = data?.data[0]?.PARTNERNAME || "";

            svgToImage(
              svgRef.current?.querySelector("svg"),
              function (imgData) {
                const imageUrls = [1].map(
                  (type) => `/images/qrGeneration/type/${type}.jpg`
                );
                const newCombinedImageUrls = {};

                imageUrls.forEach((url, index) => {
                  overlayImages(
                    url,
                    imgData,
                    {
                      x: 308,
                      y: 63,
                      width: 210,
                      height: 210,
                    },
                    function (resultImgData) {
                      const resolutionData = {
                        x: 309,
                        y: 728,
                        width: 201,
                        height: 79,
                      };
                      overlayImages(
                        resultImgData,
                        bannerImage,
                        resolutionData,
                        function (bannerImgData) {
                          drawTextOnImage(
                            bannerImgData,
                            titleStore.toUpperCase(),
                            317,
                            748,
                            "500 12px Altivo",
                            "white",
                            function (imgData) {
                              newCombinedImageUrls[index + 1] = imgData;
                              if (
                                Object.keys(newCombinedImageUrls).length ===
                                imageUrls.length
                              ) {
                                setCombinedImageUrls(newCombinedImageUrls);
                              }
                            }
                          );
                        }
                      );
                    }
                  );
                });
              }
            );
          }
        });
        console.log("resp,resp", resp);
      }
    } catch (error) {
      /* error */
    }
  }, [isLoading]);

  return (
    <div>
      <Loader isLoading={isLoading} />
      <Card>
        <CardTitle className="border-bottom p-3 mb-0 font-weight-bold text-uppercase">
          <i class="fas fa-qrcode mr-2"></i>
          Marketing Tools
        </CardTitle>
        <CardBody>
          <div>
            <div className="row">
              <div className="col-md-3 text-center">
                <div
                  style={{
                    maxWidth: "300px",
                    width: "100%",
                    marginTop: 28,
                  }}
                >
                  <div
                    style={{
                      maxWidth: "300px",
                      width: "100%",
                      padding: "20px 15px",
                      background: "#f9edf3",
                    }}
                  >
                    <h5
                      style={{
                        color: "#5e53a3",
                        fontSize: "1.2rem",
                        marginBottom: "0.8rem",
                      }}
                    >
                      Here is your
                      <br />
                      unique QR Code
                    </h5>
                    <p>
                      Download your unique QR Code and display it in your
                      business and on your current marketing materials.
                      Customers will scan this to register in your database to
                      receive cash-back offers.
                    </p>

                    <div
                      style={{
                        padding: 20,
                        borderRadius: 20,
                      }}
                    >
                      {isLoading ? null : (
                        <div ref={svgRef}>
                          <QRCodeSVG
                            height={200}
                            width={200}
                            id={"qrCode"}
                            value={qrLink}
                          />
                        </div>
                      )}
                    </div>
                    <div className={"qr-item__controls"}>
                      <a onClick={downloadSVG}>
                        <DownloadIcon />
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-9" style={{ marginTop: 25 }}>
                {windowDimensions.width < 1585 ? (
                  <>
                    <h3
                      style={{
                        color: "#5e53a3",
                        lineHeight: "28px",
                      }}
                    >
                      Your business listing image is pre-populated in the
                      leaflets below, so start building out your database by
                      downloading one or more and displaying them in your
                      business.
                    </h3>
                    <p>
                      Start building your database and increase customer
                      engagement by downloading and printing one or more of the
                      marketing pieces below. Then, strategically place them
                      throughout your business as counter cards, table cards, or
                      an exterior A-Board. Consider any visible area frequented
                      by customers—such as store windows, doors, table tops, or
                      even bathrooms—our eye-catching designs and messaging will
                      draw attention and encourage customer interaction.
                    </p>
                  </>
                ) : (
                  <>
                    <h3
                      style={{
                        color: "#5e53a3",
                        lineHeight: "28px",
                      }}
                    >
                      Your business listing image is pre-populated in the
                      leaflets below, so start building out your
                      <br />
                      database by downloading one or more and displaying them in
                      your business.
                    </h3>
                    <p>
                      Start building your database and increase customer
                      engagement by downloading and printing one or more of the
                      marketing
                      <br />
                      pieces below. Then, strategically place them throughout
                      your business as counter cards, table cards, or an
                      exterior A-Board.
                      <br />
                      Consider any visible area frequented by customers—such as
                      store windows, doors, table tops, or even bathrooms—our
                      eye-
                      <br />
                      catching designs and messaging will draw attention and
                      encourage customer interaction.
                    </p>
                  </>
                )}
                <div className="row">
                  <div className="col-md-12">
                    <div className="qr-items">
                      <div className="qr-item">
                        {combinedImageUrls && (
                          <img
                            src={combinedImageUrls[1]}
                            alt="Combined with QR Code"
                          />
                        )}
                        <div className={"qr-item__controls"}>
                          <a
                            data-fancybox="gallery"
                            href={combinedImageUrls[1]}
                          >
                            <SearchIcon />
                          </a>
                          <a
                            download={`${name}.png`}
                            href={combinedImageUrls[1]}
                          >
                            <DownloadIcon />
                          </a>
                        </div>
                      </div>
                      <div className="qr-item">
                        <img
                          src={example1}
                          alt="A-Board Example 2"
                          style={{
                            width: 630,
                            height: 387,
                          }}
                        />
                        <span
                          style={{
                            width: 602,
                            display: "flex",
                            whiteSpace: "break-spaces",
                            color: "#5e53a3",
                            fontWeight: "bold",
                            marginTop: 12,
                          }}
                        >
                          {
                            "Display the QR Code prominently in your business so customers can\nsubscribe to your database and opt-in to receive SMS text messages."
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default GenerateQrCode;
